/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Alert,
    AlertFromJSON,
    AlertToJSON,
    AlertPartialUpdate,
    AlertPartialUpdateFromJSON,
    AlertPartialUpdateToJSON,
    AlertUpdate,
    AlertUpdateFromJSON,
    AlertUpdateToJSON,
    KapacitorAlert,
    KapacitorAlertFromJSON,
    KapacitorAlertToJSON,
} from '../models';

export interface GetAlertRequest {
    id: number;
}

export interface GetAllAlertsRequest {
    isOpen?: string;
    id?: number;
    ordering?: string;
    limit?: number;
    offset?: number;
}

export interface PatchAlertRequest {
    id: number;
    alertPartialUpdate: AlertPartialUpdate;
}

export interface SubmitKapacitorAlertRequest {
    kapacitorAlert: KapacitorAlert;
}

export interface UpdateAlertRequest {
    id: number;
    alertUpdate: AlertUpdate;
}

/**
 * 
 */
export class StatusApi extends runtime.BaseAPI {

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async getAlertRaw(requestParameters: GetAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Alert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/alerts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AlertFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async getAlert(requestParameters: GetAlertRequest, initOverrides?: RequestInit): Promise<Alert> {
        const response = await this.getAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async getAllAlertsRaw(requestParameters: GetAllAlertsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Alert>>> {
        const queryParameters: any = {};

        if (requestParameters.isOpen !== undefined) {
            queryParameters['is_open'] = requestParameters.isOpen;
        }

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/alerts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AlertFromJSON));
    }

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async getAllAlerts(requestParameters: GetAllAlertsRequest, initOverrides?: RequestInit): Promise<Array<Alert>> {
        const response = await this.getAllAlertsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async getTelegrafStatsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/telegraf-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * <class \'rest_framework.permissions.AllowAny\'> 
     */
    async getTelegrafStats(initOverrides?: RequestInit): Promise<void> {
        await this.getTelegrafStatsRaw(initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async patchAlertRaw(requestParameters: PatchAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Alert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchAlert.');
        }

        if (requestParameters.alertPartialUpdate === null || requestParameters.alertPartialUpdate === undefined) {
            throw new runtime.RequiredError('alertPartialUpdate','Required parameter requestParameters.alertPartialUpdate was null or undefined when calling patchAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/alerts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AlertPartialUpdateToJSON(requestParameters.alertPartialUpdate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AlertFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async patchAlert(requestParameters: PatchAlertRequest, initOverrides?: RequestInit): Promise<Alert> {
        const response = await this.patchAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * localhost only 
     */
    async submitKapacitorAlertRaw(requestParameters: SubmitKapacitorAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.kapacitorAlert === null || requestParameters.kapacitorAlert === undefined) {
            throw new runtime.RequiredError('kapacitorAlert','Required parameter requestParameters.kapacitorAlert was null or undefined when calling submitKapacitorAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/alerts/submit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KapacitorAlertToJSON(requestParameters.kapacitorAlert),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ### Required permissions    * localhost only 
     */
    async submitKapacitorAlert(requestParameters: SubmitKapacitorAlertRequest, initOverrides?: RequestInit): Promise<void> {
        await this.submitKapacitorAlertRaw(requestParameters, initOverrides);
    }

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async updateAlertRaw(requestParameters: UpdateAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Alert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateAlert.');
        }

        if (requestParameters.alertUpdate === null || requestParameters.alertUpdate === undefined) {
            throw new runtime.RequiredError('alertUpdate','Required parameter requestParameters.alertUpdate was null or undefined when calling updateAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/alerts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AlertUpdateToJSON(requestParameters.alertUpdate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AlertFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * User account permission: `system:status:view` 
     */
    async updateAlert(requestParameters: UpdateAlertRequest, initOverrides?: RequestInit): Promise<Alert> {
        const response = await this.updateAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
